// §H (virality) — CREATOR-side referral capture.
//
// The generated-app runtime has had captureReferral() since F-wave, but the
// CREATOR never captured anything: a viewer tapping the "Built with Pomela"
// badge (?ref=…&utm_…) landed on pomela.app and the params were simply
// ignored — attribution lost. This runs in the boot sequence (before the
// maintenance gate renders, so waitlist-phase badge taps are attributed too).
//
// - `ref` → vs_ref cookie (90 days) + a referral_landed analytics event
// - the params are stripped from the URL afterwards (preserving the rest)

const REF_COOKIE = 'vs_ref';
const NINETY_DAYS = 90 * 24 * 60 * 60;

export function captureCreatorReferral(): void {
  const url = new URL(window.location.href);
  // §REFERRAL-CANONICAL. `ref` is canonical, but the INVITE surfaces (InviteCard, SettingsV2)
  // have always emitted `?r=<code>` while every reader looked only at `ref` — so human invites,
  // the highest-intent referral we have, were attributed to nobody. Badge/share links use `ref`
  // and did work, which is why the loop looked half-alive rather than broken.
  // Accepting BOTH is deliberate: `?r=` links are already distributed and cannot be recalled,
  // so fixing only the emitters would abandon every invite in the wild.
  const ref = url.searchParams.get('ref') || url.searchParams.get('r');
  if (!ref) return;

  if (/^[a-z0-9][a-z0-9-]{0,63}$/i.test(ref)) {
    // First-touch wins — a stored referrer is never overwritten.
    if (!document.cookie.split(';').some((c) => c.trim().startsWith(`${REF_COOKIE}=`))) {
      document.cookie = `${REF_COOKIE}=${encodeURIComponent(ref)}; max-age=${NINETY_DAYS}; path=/; SameSite=Lax`;
    }
    try {
      (window as { posthog?: { capture: (e: string, p?: Record<string, unknown>) => void } }).posthog?.capture('referral_landed', {
        ref,
        utm_source: url.searchParams.get('utm_source'),
        utm_medium: url.searchParams.get('utm_medium'),
        surface: 'creator'
      });
    } catch { /* analytics is best-effort */ }
  }

  // `r` is stripped alongside `ref`, or the invite code would survive in the address bar and
  // propagate into whatever the visitor shares next, mis-attributing their referrals to us.
  for (const p of ['ref', 'r', 'utm_source', 'utm_medium', 'utm_campaign']) url.searchParams.delete(p);
  try { window.history.replaceState({}, '', url.toString()); } catch { /* non-fatal */ }
}
